import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import SEO from "@/components/SEO";

export default function ImpressumPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <SEO 
        title="Impressum | Personal Fußballtraining"
        description="Impressum und rechtliche Angaben von Fußballtraining Aktas. Kontaktinformationen und verantwortliche Person gemäß § 5 TMG."
        path="/impressum"
      />
      {/* Header */}
      <div className="bg-[#0A0A0A] border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-[#c1ff72] transition-colors"
          >
            <ChevronLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="font-['Bebas_Neue'] text-4xl md:text-5xl text-white mb-8">
          Impressum
        </h1>

        <div className="prose prose-invert prose-lg max-w-none">
          <p className="text-[#A1A1AA] mb-6">Angaben gemäß § 5 TMG</p>
          
          <p className="text-white text-xl font-semibold mb-6">Fußballtraining Aktas</p>

          <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mt-10 mb-4">Anschrift</h2>
          <p className="text-white/80">
            Unterm Hestenberg 2<br />
            58540 Meinerzhagen<br />
            Deutschland
          </p>

          <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mt-10 mb-4">Kontakt</h2>
          <p className="text-white/80">
            Telefon: <a href="tel:+491741944996" className="text-[#c1ff72] hover:underline">+49 174 1944996</a><br />
            E-Mail: <a href="mailto:kontakt@fussballtraining-aktas.de" className="text-[#c1ff72] hover:underline">kontakt@fussballtraining-aktas.de</a>
          </p>

          <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mt-10 mb-4">
            Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
          </h2>
          <p className="text-white/80">
            Yasin Aktas<br />
            Unterm Hestenberg 2<br />
            58540 Meinerzhagen
          </p>

          <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mt-10 mb-4">Umsatzsteuer</h2>
          <p className="text-white/80">
            Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:<br />
            332/5001/6405
          </p>

          <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mt-10 mb-4">Haftung für Inhalte</h2>
          <p className="text-white/80">
            Als Diensteanbieter sind wir gemäß den gesetzlichen Vorschriften für eigene Inhalte auf diesen Seiten verantwortlich. Trotz sorgfältiger Prüfung übernehmen wir keine Gewähr für die Aktualität, Vollständigkeit und Richtigkeit der bereitgestellten Inhalte.
          </p>

          <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mt-10 mb-4">Haftung für Links</h2>
          <p className="text-white/80">
            Unsere Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte übernehmen wir keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
          </p>

          <h2 className="font-['Bebas_Neue'] text-2xl text-[#c1ff72] mt-10 mb-4">Urheberrecht</h2>
          <p className="text-white/80">
            Die durch den Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht. Jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung des jeweiligen Rechteinhabers.
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-white/10 py-8">
        <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[#71717A] text-sm">
            © {new Date().getFullYear()} Fußballtraining Aktas
          </p>
          <div className="flex gap-6">
            <Link to="/impressum" className="text-[#A1A1AA] hover:text-[#c1ff72] text-sm transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-[#A1A1AA] hover:text-[#c1ff72] text-sm transition-colors">
              Datenschutz
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
